module.exports = __webpack_public_path__ + "static/media/4XL.778c50a1.jpg";